import React from 'react';
import { oneOf } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import css from './MarketplaceProcessDiagram.module.css';

const processContent = {
  buying: {
    title: 'MarketplaceProcessDiagram.buying.title',
    description: 'MarketplaceProcessDiagram.buying.description',
    steps: ['discover', 'review', 'purchase', 'receive'],
  },
  selling: {
    title: 'MarketplaceProcessDiagram.selling.title',
    description: 'MarketplaceProcessDiagram.selling.description',
    steps: ['join', 'list', 'sell', 'dispatch'],
  },
};

/**
 * A concise visual explanation of the marketplace buying or selling journey.
 *
 * @component
 * @param {Object} props
 * @param {'buying' | 'selling'} props.variant
 * @returns {JSX.Element} Responsive marketplace process diagram.
 */
const MarketplaceProcessDiagram = props => {
  const { variant } = props;
  const content = processContent[variant];
  const headingId = `marketplace-${variant}-process-title`;

  return (
    <section className={css.root} aria-labelledby={headingId}>
      <div className={css.content}>
        <div className={css.intro}>
          <h2 id={headingId} className={css.title}>
            <FormattedMessage id={content.title} />
          </h2>
          <p className={css.description}>
            <FormattedMessage id={content.description} />
          </p>
        </div>

        <ol className={css.steps}>
          {content.steps.map((step, index) => {
            const messagePrefix = `MarketplaceProcessDiagram.${variant}.${step}`;

            return (
              <li key={step} className={css.step}>
                <div className={css.marker} aria-hidden="true">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <div className={css.stepBody}>
                  <h3 className={css.stepTitle}>
                    <FormattedMessage id={`${messagePrefix}.title`} />
                  </h3>
                  <p className={css.stepDescription}>
                    <FormattedMessage id={`${messagePrefix}.description`} />
                  </p>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

MarketplaceProcessDiagram.propTypes = {
  variant: oneOf(['buying', 'selling']).isRequired,
};

export { processContent };
export default MarketplaceProcessDiagram;
